import React, { useEffect, useState } from "react";
import { searchCourse } from "../../services/CourseService";
import { StatusBadge } from "../SharedInputs";

function CourseList({ onSelectCourse }) {
  const [courses, setCourses] = useState([]); 
  const [searchText, setSearchText] = useState("");
  const [statusFilter, setStatusFilter] = useState("active");
  
    const fetchCourses = async () => {
      try {
        const data = await searchCourse(searchText);
        setCourses(data || []);
      } catch (error) {
        alert("Error fetching courses");
      }
    };
  
    useEffect(() => {
      fetchCourses();
    }, [searchText]);

   // --- UI styles ---
  const barWrap = {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    marginBottom: 16,
    gap: "1rem",
  };

  const chip = {
    display: "flex",
    alignItems: "center",
    gap: 8,
    background: "#fff",
    border: "1px solid #e5e7eb",
    borderRadius: 10,
    padding: "0.7rem",
    boxShadow: "0 1px 2px rgba(0,0,0,0.04)",
  };

  const searchInputStyle = {
    maxWidth: "300px",
    flex: 1,
  };
  const statusCounts = courses.reduce(
    (acc, c) => {
      const status = (c.status || "").toLowerCase();
      acc[status] = (acc[status] || 0) + 1;
      return acc;
    },
    { active: 0, inactive: 0 }
  );

  const filteredCourses =
    statusFilter === "all"
      ? courses
      : courses.filter(
          (c) => (c.status || "").toLowerCase() === statusFilter
        );

  return (
    <div className="record-list">
      {/* Search and Filter on the same line */}
      <div style={barWrap}>
        <input
          type="text"
          placeholder="Search by Code, Name..."
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          className="form-input"
          style={searchInputStyle}
        />

        <div style={chip}>
          <span style={{ fontSize: 13, color: "#6b7280", fontWeight: 600 }}>
            Status
          </span>
          <select
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
            style={{
              border: "none",
              background: "transparent",
              fontSize: 14,
              outline: "none",
              padding: "4px 6px",
              cursor: "pointer",
            }}
          >
            <option value="active">
              Active ({statusCounts.active || 0})
            </option>
            <option value="inactive">
              Inactive ({statusCounts.inactive || 0})
            </option>
            <option value="all">
              All ({courses.length})
            </option>
          </select>
        </div>
      </div>
      <table className="record-table" style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr style={{ borderBottom: "2px solid #ddd" }}>
            <th style={{ padding: "8px", textAlign: "center" }}>Course Code</th>
            <th style={{ padding: "8px", textAlign: "center" }}>Course Name</th>
            <th style={{ padding: "8px", textAlign: "center" }}>Course Duration</th>
            <th style={{ padding: "8px", textAlign: "center" }}>Course Fees</th>
            <th style={{ padding: "8px", textAlign: "center" }}>Status</th>
          </tr>
        </thead>
        <tbody>
          {filteredCourses.map((course) => (
            <tr
              key={course.id || course.courseCode}
              onClick={() => onSelectCourse && onSelectCourse(course)}
              style={{ cursor: "pointer", borderBottom: "1px solid #eee" }}
            >
              <td style={{ padding: "8px", textAlign: "center" }}>{course.courseCode}</td>
              <td style={{ padding: "8px", textAlign: "center" }}>{course.courseName}</td>
              <td style={{ padding: "8px", textAlign: "center" }}>{course.duration || "-"} weeks</td>
              <td style={{ padding: "8px", textAlign: "center" }}>${course.fee}.00</td>
              <td style={{ padding: "8px", textAlign: "center" }}><StatusBadge status={course.status || "-"}/></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default CourseList;
